// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"fa73d562","839":"f29fdc5b"}[chunkId] + ".chunk.js";
};